import React from "react"

import shape1 from "../../images/about/about-shape1.png"
import DynamicImage from "../common/DynamicImage"
import { getBackgroundClass, getLayoutClass } from "../../utils/sectionHelpers";
import { Link } from "react-router-dom";
import { HighlightText } from "../common/HighlightText";

const AboutUs = ({ data }) => {
    const settings = data?.Settings || {};
  
    const backgroundClass = getBackgroundClass(settings.background);
    const layoutClass = getLayoutClass(settings.layout);
  return (
    <>
      <section className={`about-area ptb-70 service-about-area overflow-hidden uiux-about-sec ${backgroundClass}`}>
        <div className="container">
          <div className="row justify-content-center mb-3">
            <div className="col-lg-9" data-aos="fade-up" data-aos-duration="1200">
              <div className="content text-start text-lg-center">
                {/* <h2>{data?.title}</h2>
                {data?.description?.map((block, index) => {
                  if (block.type === "paragraph") {
                    return (
                      <p key={index}>
                        {block.children.map((child) => child.text).join("")}
                      </p>
                    );
                  }
                  return null;
                })} */}

                 {data?.secTitle?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                        <p key={index}>
                          {block.children.map(c => c.text).join("")}
                        </p>
                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          <HighlightText content={block.children.map(c => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      return (
                        <ul key={index} className="list-unstyled">
                          {block.children.map((item, i) => (
                            <li key={i} className="features-text">
                              <h4>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map(c => c.text).join("")}
                              </h4>
                            </li>
                          ))}
                        </ul>
                      );

                    default:
                      return null;
                  }
                })}
              </div>
            </div>
          </div>
          <div className={`row align-items-center justify-content-center gy-4 gx-lg-5 ${layoutClass}`}>
            <div className="col-lg-6 col-md-12 order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1200">
              <div className="about-img">
                <DynamicImage image={data?.image} />
                <div className="shape">
                  <img src={shape1} alt="about" />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 order-1 order-lg-2" data-aos="fade-up" data-aos-duration="1200">
              <div className="about-content text-start">
                <div className="content">
                  {/* <ul className="content-list">
                    <h4 className="mb-4">We Focus on:</h4>
                    <li>
                      <i className="flaticon-tick"></i> User Value → improving ease of use & emotional engagement

                    </li>
                    <li>
                      <i className="flaticon-tick"></i> Business Targets → driving acquisition, retention & profitability
                    </li>
                    <li>
                      <i className="flaticon-tick"></i> Technology Compatibility → ensuring scalable and efficient development
                    </li>
                    <li>
                      <i className="flaticon-tick"></i> Brand Consistency → building recognizable and trustworthy identity
                    </li>
                  </ul> */}
                    {data?.description?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                       <p key={index}>
                                    {block.children.map((child, i) => {
                                        let textElement = child.text;

                                        if (child.bold) {
                                            textElement = <strong>{textElement}</strong>;
                                        }

                                        if (child.italic) {
                                            textElement = <em>{textElement}</em>;
                                        }

                                        if (child.underline) {
                                            textElement = <u>{textElement}</u>;
                                        }

                                        if (child.strikethrough) {
                                            textElement = <s>{textElement}</s>;
                                        }

                                        return <React.Fragment key={i}>{textElement}</React.Fragment>;
                                    })}
                                </p>
                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                         <HighlightText content={block.children.map(c => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      const ListTag = block.format === "ordered" ? "ol" : "ul";

                      return (
                          <ListTag key={index} className="content-list">
                              {block.children.map((item, i) => (
                                  <li key={i}>
                                          <i className="flaticon-tick"></i>
                                          <span>
                                              {item.children.map((child, j) => {

                                                  const isBold =
                                                      child.bold ||
                                                      child.marks?.some(mark => mark.type === "bold");

                                                  if (isBold) {
                                                      return <b key={j}>{child.text}</b>;
                                                  }

                                                  return child.text;
                                              })}
                                          </span>
                                  </li>
                              ))}
                          </ListTag>
                      );

                    default:
                      return null;
                  }
                })}
                  {/* {data?.description?.map((block, index) => {
                    if (block.type === "list" && block.format === "unordered") {
                      return (
                        <ul key={index} className="content-list">
                          {block.children.map((item, i) => (
                            <li key={i}>
                              <i className="flaticon-tick"></i>{" "}
                              {item.children.map(child => child.text).join("")}
                            </li>
                          ))}
                        </ul>
                      );
                    }

                    return null;
                  })} */}
                  {data?.secButton?.url && (
                    <Link
                      to={data.secButton.url}
                      target="_blank"
                      rel="noreferrer"
                      className="default-btn"
                    >
                      {/* ICON LOGIC */}
                      {data?.secButton?.icon ? (
                        <DynamicImage image={data.secButton.icon} className="btn-icon" />
                      ) : (
                        <i className="bx bx-support"></i>  // Default icon
                      )}

                      <span className="default-btn-text">
                        {data.secButton.label}
                      </span>

                      <span className="default-btn-hover"></span>
                    </Link>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AboutUs
